export const GET_USERS_SUCCESS = "GET_USERS_SUCCESS";
export const GET_USERS_FAIL = "GET_USERS_FAIL";
export const GET_SELECTED_USER = "GET_SELECTED_USER";
export const SEND_MESSAGE = "SEND_MESSAGE";
export const SET_USER_MESSAGES = "SET_USER_MESSAGES";
